// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"index__placeholder___74FZk","feature":"index__feature___mdAs7","square":"index__square___3G9RP","poster":"index__poster___1GYnH","standard":"index__standard___2HO3S"};